<template>
  <div class="my-content">
    <div class="left-content">
      <Form
        label-position="right"
        :model="dataDetails"
        :label-width="140"
        :rules="ruleFrom"
        ref="dataDetails"
      >
        <FormItem :label="$t('clientName')" prop="client_id">
          <Select
            v-model="dataDetails.client_id"
            filterable
            :placeholder="$t('select') + $t('clientName')"
						@on-change="getWarehouseNumber"
          >
            <Option
              v-for="item in clientList"
              :value="item.id"
              :key="item.id"
              :label="item.account"
              >{{ item.account }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('airport')" prop="target_airport">
          <Select
            v-model="dataDetails.target_airport"
            filterable
            :placeholder="$t('select') + $t('airport')"
          >
            <Option
              v-for="item in airportList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('warehouseName')" prop="warehouse_id">
          <Select
            v-model="dataDetails.warehouse_id"
            filterable
            :placeholder="$t('select') + $t('warehouseName')"
            @on-change="changeWarehouse"
          >
            <Option
              v-for="item in warehouseList"
              :value="item.id"
              :key="item.id"
              >{{ item.title }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('clearance_agent')">
          <Select
            v-model="dataDetails.clearance_agent"
            filterable
            clearable
            :placeholder="$t('select') + $t('clearance_agent')"
          >
            <Option
              v-for="item in channelList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('packing_number')" prop="packing_number">
          <i-Input
            v-model="dataDetails.packing_number"
            :placeholder="$t('enter') + $t('packing_number')"
          ></i-Input>
        </FormItem>
        <FormItem :label="$t('HKagency')" prop="hk_agent">
          <Select
            v-model="dataDetails.hk_agent"
            filterable
            clearable
            :placeholder="$t('select') + $t('HKagency')"
          >
            <Option
              v-for="item in hkAgentList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <!-- <Row>
          <Col span="8">
            <FormItem :label="$t('length') + '(cm)'">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.length"
                :placeholder="$t('enter') + $t('length')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('width') + '(cm)'">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.width"
                :placeholder="$t('enter') + $t('width')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('height') + '(cm)'">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.height"
                :placeholder="$t('enter') + $t('height')"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row> -->
        <Row>
          <Col span="8">
            <FormItem :label="$t('invoicePCS')">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.quantity"
                :placeholder="$t('enter') + $t('invoicePCS')"
              ></InputNumber> </FormItem
          ></Col>
          <Col span="8">
            <FormItem :label="$t('invoiceWeight') + '(kg)'">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.weight"
                :placeholder="$t('enter') + $t('invoiceWeight')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="8"
            ><FormItem :label="$t('skuVolume') + '(cbm)'">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.volume"
                :placeholder="$t('enter') + $t('skuVolume')"
              ></InputNumber> </FormItem
          ></Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem :label="$t('ElectricityPCS')" prop="charged_num">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.charged_num"
                :placeholder="$t('enter') + $t('ElectricityPCS')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label="$t('liquidPCS')">
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.liquid_num"
                :placeholder="$t('enter') + $t('liquidPCS')"
              ></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem
              :label="$t('Billing') + $t('invoiceWeight')"
              prop="charging_weight"
            >
              <InputNumber
                style="width: 100%"
                :min="0"
                v-model="dataDetails.charging_weight"
                :placeholder="$t('enter') + $t('Billing') + $t('invoiceWeight')"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <FormItem :label="$t('delivery_method')" prop="lower_port">
          <Select
            v-model="dataDetails.lower_port"
            filterable
            :placeholder="$t('select') + $t('delivery_method')"
            :filter-by-label="true"
          >
            <Option
              v-for="item in downPortList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
				<FormItem :label="$t('batch_number')" prop="batch_id">
				  <Select
				    v-model="dataDetails.batch_id"
				    filterable
						clearable
						multiple
				    :placeholder="$t('select') + $t('batch_number')"
				    :filter-by-label="true"
						@on-change="batchChange"
				  >
				    <Option
				      v-for="item in warehouse_number"
				      :value="item.value"
				      :key="item.value"
				      >{{ item.label }}</Option
				    >
				  </Select>
				</FormItem>
        <!-- <FormItem :label="$t('B2bOrderNo')">
          <Input
            v-model="dataDetails.airway_number"
            type="textarea"
            :rows="3"
            :placeholder="$t('enter') + $t('B2bOrderNo')"
          ></Input>
        </FormItem> -->
        <FormItem :label="$t('order_desc')" prop="remarks">
          <Input
            v-model="dataDetails.remarks"
            type="textarea"
            :rows="3"
            :placeholder="$t('enter') + $t('order_desc')"
          ></Input>
        </FormItem>
				<FormItem :label="$t('batch_number')">
				  <Batch :list="batchList"></Batch>
				</FormItem>
				<FormItem :label="$t('des_goods') +$t('information')">
				  <Goods :list="goods" read></Goods>
				</FormItem>
        <div class="btn-div">
          <!-- <Button
            type="dashed"
            class="submit-btn"
            size="large"
            @click="SearchSubmit"
            icon="md-search"
            :disabled="dataDetails.package_id.length > 0 ? false : true"
          >
            {{ $t("search") }}
          </Button> -->
          <Button
            type="primary"
            class="submit-btn"
            size="large"
            @click="submitClick"
            icon="md-add"
          >
            {{ $t("order_submit") }}
          </Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { add } from "@/api/tracker/airPacking";
import {
  getPackageWarehouse,
  dblpackingAir,
  dblpackingOrder,
  getDownPort,
	warehouse_number,
	getBatch,
} from "@/api/packing/packing";
import { getTransportAgent } from "@/api/tracker/air";
import { getAllClient } from "@/api/user/client";
import Goods from '../warehousing/goods.vue'
import Batch from './batch.vue'
export default {
  name: "airPackingNew",
	components: {
		Goods,
		Batch
	},
  data() {
    return {
			batchList:[],
			goods:[],
			warehouse_number:[],
      dataDetails: {
				batch_id:[],
        target_airport: "",
        warehouse_id: "",
        clearance_agent: "",
        packing_number: "",
        weight: 0,
        quantity: 0,
        volume: 0,
        liquid_num: 0,
        charged_num: 0,
        length: 0,
        width: 0,
        height: 0,
        client_id: "",
        hk_agent: "",
        charging_weight: 0,
        lower_port: ""
        // airway_number: ""
      },
      airportList: [],
      ruleFrom: {
        client_id: [
          {
            required: true,
            message: this.$t("select") + this.$t("clientName"),
            trigger: "change",
            type: "number"
          }
        ],
        target_airport: [
          {
            required: true,
            message: this.$t("select") + this.$t("airport"),
            trigger: "change"
          }
        ],
        warehouse_id: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("warehouseName"),
            trigger: "change"
          }
        ],
        clearance_agent: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("clearance_agent"),
            trigger: "change"
          }
        ],
        packing_number: [
          {
            required: true,
            message: this.$t("enter") + this.$t("packing_number"),
            trigger: "blur"
          }
        ],
        charged_num: [
          {
            required: true,
            type: "number",
            message: this.$t("enter") + this.$t("ElectricityPCS"),
            trigger: "blur"
          }
        ]
        // airway_number: [
        //   {
        //     required: true,
        //     // type: "array",
        //     message: this.$t("select") + this.$t("B2bOrderNo"),
        //     trigger: "blur"
        //   }
        // ]
      },
      warehouseList: [],
      channelList: [],
      loading: false,
      orderList: [],
      clientList: [],
      hkAgentList: [],
      downPortList: []
    };
  },
  mounted() {
    this.getotherList();
  },
  methods: {
		batchChange(batch_id){
			getBatch({batch_id}).then(res=>{
				if(res.data.status){
					this.batchList = res.data.payload.batch
					Array(this.goods.length).fill(1).forEach(t=>this.goods.pop())
					res.data.payload.goods.forEach(t=>{
						this.goods.push(t)
					})
					this.dataDetails.quantity = res.data.payload.quantity
					this.dataDetails.volume = res.data.payload.volume
					this.dataDetails.weight = res.data.payload.weight
				}
			})
		},
		getWarehouseNumber(){
			this.dataDetails.batch_id = []
			if(this.dataDetails.client_id && this.dataDetails.warehouse_id){
				warehouse_number({client_id:this.dataDetails.client_id,warehouse_id:this.dataDetails.warehouse_id}).then((res)=>{
					if(res.data.status){
						this.warehouse_number = res.data.payload
					}
				})
			}
		},
    getotherList() {
      getPackageWarehouse().then(res => {
        this.warehouseList = res.data.payload;
      });
      dblpackingAir().then(res => {
        this.airportList = res.data.payload;
      });
      getTransportAgent().then(res => {
        this.channelList = res.data.payload;
      });
      getTransportAgent({ type: 4 }).then(res => {
        this.hkAgentList = res.data.payload;
      });
      getAllClient().then(res => {
        this.clientList = res.data.payload.rows;
      });
      getDownPort().then(res => {
        this.downPortList = res.data.payload;
      });
    },
    submitClick() {
      this.$refs["dataDetails"].validate(valid => {
        if (valid) {
          let data = this.dataDetails;
          data["method"] = "post";
          add(data).then(res => {
            if (res.data.code == 0) {
              this.$refs["dataDetails"].resetFields();
              this.$Message["success"]({
                background: true,
                content: res.data.msg
              });
            } else {
              this.$Message["error"]({
                background: true,
                content: res.data.msg
              });
            }
          });
        }
      });
    },
    changeWarehouse(val) {
			this.getWarehouseNumber()
      // if (val) {
      //   let data = {
      //     warehouse_id: val
      //   };
      //   dblpackingOrder(data).then(res => {
      //     this.orderList = res.data.payload;
      //   });
      // } else {
      //   this.orderList = [];
      // }
      // this.dataDetails.airway_number = [];
    }
  }
};
</script>

<style scoped lang="less">
.my-content {
  min-height: 100%;
  display: flex;
  background: #fff;
}
.left-content {
  width: 70%;
  margin: 0 auto;
  height: 100%;
  background: #fff;
  padding: 10px;
}
.right-content {
  width: 470px;
  height: 100%;
  margin-left: 30px;
  background: #fff;
  padding: 10px;
}
.submit-btn {
  width: 150px;
  margin: 0 20px;
}
.btn-div {
  width: 100%;
  display: flex;
  justify-content: center;
}
.search-div {
  display: flex;
  margin-bottom: 24px;
}
.search-div button {
  margin-left: 20px;
}
.bag-code {
  border: 1px solid #dcdee2;
  height: 400px;
  border-radius: 4px;
}
.check-all {
  position: absolute;
  width: 100%;
  top: 0;
  border-bottom: 1px solid #e9e9e9;
  padding: 0 15px;
}
.check-client {
  position: absolute;
  top: 40px;
  width: 100%;
  height: 400px;
  overflow: auto;
  padding: 0 10px;
}
</style>
